import { envVars, IEnvironment } from './env-vars';

export const environment: IEnvironment = {
  production: false,
  ngrxDevTools: true,
  name: envVars.Enviroments.qa,
  version: envVars.version,
  apiHost: envVars.ApiHost.QaUs,
  appCode: envVars.appCode,
  countlyKey: envVars.CountlyKey.Qa,
  countlyUrl: envVars.countlyUrl,
  mapApiKey: envVars.MapKey.Qa,
  appInsightsKey: envVars.AppInsightsKey.QaUs,
  roxKey: envVars.RoxKey.Qa,
  pcmUrl: envVars.PcmUrl.Qa,
  pcmRegionNames: envVars.PcmRegionNames.Qa,
  walkMeUrl: envVars.WalkMeUrl.Qa,
  chatBotWizelineUrl: envVars.ChatbotWizelineUrl.Qa,
  ocpApimSubscriptionKey: envVars.OcpApimSubscriptionKey.Qa,
  cobrowseKey: envVars.cobrowseKey,
  translations: {
    apiHost: envVars.translations.ApiHost.QaUs,
    appName: envVars.translations.AppName,
    languagePath: envVars.translations.LanguagePath.QaUs,
    translationPath: envVars.translations.TranslationPath.QaUs,
    defaultLanguage: envVars.translations.defaultLanguage,
  },
  features: {
    uploadDocuments: false,
    shiftBusinessLines: false,
    showLanguageSelector: false,
  },
  applicationCode: envVars.applicationCode.Qa,
};
